import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCheck, FiHash, FiDelete } = FiIcons;

const QuickTablePickerModal = ({ isOpen = false, onClose, onSelectTable, activeTables = [] }) => {
  const [inputVal, setInputVal] = useState('');

  if (!isOpen) return null;

  const handleDigit = (digit) => {
    if (inputVal.length >= 3) return;
    const nextVal = inputVal + digit.toString();
    const num = parseInt(nextVal, 10);
    if (num <= 200) {
      setInputVal(nextVal);
    }
  };

  const handleDelete = () => {
    setInputVal(prev => prev.slice(0, -1));
  };

  const handleConfirm = () => {
    const num = parseInt(inputVal, 10);
    if (num >= 1 && num <= 200) {
      onSelectTable(num);
      onClose();
    }
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 border border-gray-100"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-bold text-gray-900 flex items-center">
              <SafeIcon icon={FiHash} className="w-5 h-5 mr-1.5 text-[#5C715E]" />
              Seleziona Numero Tavolo (1-200)
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 p-1.5 rounded-lg hover:bg-gray-100"
            >
              <SafeIcon icon={FiX} className="w-5 h-5" />
            </button>
          </div>

          {/* Display Numero */}
          <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-4 text-center mb-5">
            <div className="text-4xl font-black text-gray-900 tracking-wider h-10 flex items-center justify-center">
              {inputVal ? `Tavolo ${inputVal}` : <span className="text-gray-300">Es. 12</span>}
            </div>
            {inputVal && activeTables.includes(parseInt(inputVal, 10)) && (
              <div className="text-xs text-orange-600 font-semibold mt-1">
                Tavolo già occupato (aggiungerai piatti al conto esistente)
              </div>
            )}
          </div>

          {/* Numpad Ergonomico */}
          <div className="grid grid-cols-3 gap-2.5 mb-5">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((digit) => (
              <button
                key={digit}
                type="button"
                onClick={() => handleDigit(digit)}
                className="py-3.5 text-xl font-bold bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-xl transition-colors active:scale-95"
              >
                {digit}
              </button>
            ))}
            <button
              type="button"
              onClick={handleDelete}
              className="py-3.5 text-lg font-bold bg-red-50 hover:bg-red-100 text-red-600 rounded-xl flex items-center justify-center transition-colors active:scale-95"
            >
              <SafeIcon icon={FiDelete} className="w-6 h-6" />
            </button>
            <button
              type="button"
              onClick={() => handleDigit(0)}
              className="py-3.5 text-xl font-bold bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-xl transition-colors active:scale-95"
            >
              0
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={!inputVal || parseInt(inputVal, 10) < 1}
              className="py-3.5 text-lg font-bold bg-[#5C715E] hover:bg-[#4B5C4D] text-white rounded-xl flex items-center justify-center transition-all disabled:opacity-40 active:scale-95 shadow-md"
            >
              <SafeIcon icon={FiCheck} className="w-6 h-6" />
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default QuickTablePickerModal;
